<div *ngIf="layoutModel && layoutModel.isVisible">
  <wm-data-entity-input-list
    [form]="form"
    [entities]="layoutModel.rowEntities"
    [applicationId]="applicationId"
    [activity]="activity"
    [isPreview]="isReadOnly"
    [orientation]="'horizontal'"
    #dataEntityInputList
  >
  </wm-data-entity-input-list>
</div>
